import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Button from 'antd/lib/button';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Checkbox from 'antd/lib/checkbox';
import Select from 'antd/lib/select';
import rules from '../../../common/rules/rules';
import accountRules from '../../../common/rules/accountRules';
import {
  accountRolesT,
  accountRegistrationStatuses,
  accountRegistrationStatusesT,
  adminRolesT,
} from '../../../common/enums';
import { formatDateTime, currencyFormatter } from '../../../common/utils/helpers';
import { AcceptDocumentsModal, RejectDocumentsModal } from './documents';
import { t } from '../../../app/i18n';

const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 14 },
};

const tailFormItemLayout = {
  wrapperCol: {
    span: 14,
    offset: 7,
  },
};

@translate()
@Form.create()
export default class AccountForm extends Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    isEditable: PropTypes.bool.isRequired,
    onAcceptDocuments: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onRejectDocuments: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isDebtor: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    accountUpdateLogs: PropTypes.object

  };

  handleSubmit = e => {
    e.preventDefault();

    const { form, onSubmit } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        onSubmit(values);
      }
    });
  };

  handleEdit = e => {
    e.preventDefault();
    const { account, onEdit } = this.props;
    onEdit(account.id);
  };

  handleCancelEdit = e => {
    e.preventDefault();
    const { onEdit } = this.props;
    onEdit('');
  };

  handleRejectDocumentsSubmit = rejectReason => this.props.onRejectDocuments(rejectReason);

  getUpdateLogByAttribute = (logs, attributeName) => {
    if (logs.data && logs.data.length > 0) {
      let log = logs.data.find(l => l.attributeName == attributeName)
      if (log) {
        return t(`Naposledy zmenené: ${formatDateTime(log.lastUpdatedAt)}, zmenil ${log.updatedByName}`)
      }
    }
  }

  render() {
    const { account, isEditable, onAcceptDocuments, isDebtor, isAdmin, t, accountUpdateLogs } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Item {...formItemLayout} label={t('Meno')}>
          {!isEditable && <span>{account.nameFirst}</span>}
          {isEditable &&
            getFieldDecorator('nameFirst', {
              rules: rules.required,
              initialValue: account.nameFirst,
            })(<Input size="default" placeholder={t('Meno')} autoFocus />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Priezvisko')}>
          {!isEditable && <span>{account.nameLast}</span>}
          {isEditable &&
            getFieldDecorator('nameLast', {
              rules: rules.required,
              initialValue: account.nameLast,
            })(<Input size="default" placeholder={t('Priezvisko')} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('E-mail')}>
          {isEditable && isAdmin ? (
            getFieldDecorator('email', {
              rules: accountRules.email,
              initialValue: account.email != "" ? account.email : account.profileData.email,
            })(<Input size="default" placeholder={t('E-mail')} type="email" />)
          ) : (
            <span>{account.email != "" ? account.email : account.profileData.email}</span>
          )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Rola')}>
          {isEditable && isAdmin ? (
            getFieldDecorator('role', {
              rules: rules.required,
              initialValue: account.role
            })(
              <Select size="default" placeholder={t('Vybrať rolu')}>
                {Object.entries(adminRolesT).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
                ))}
              </Select>
            )
          ) : (
              <span>{accountRolesT[account.role]}</span>
            )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Stav registrácie')}>
          <span>{accountRegistrationStatusesT[account.registrationStatus]}</span>
        </Form.Item>

        {isAdmin && (
          <Form.Item
            {...formItemLayout}
            label={isDebtor ? t('Číslo dlžníka') : t('Číslo investora / Variabilný sym.')}
          >
            <span>{account.accountNumber}</span>
          </Form.Item>
        )}

        <Form.Item {...formItemLayout} label={t('Deaktivovaný')}>
          {!isEditable && (account.locked ? t('Áno') : t('Nie'))}
          {isEditable &&
            getFieldDecorator('locked', {
              rules: rules.required,
              initialValue: account.locked,
            })(<Checkbox defaultChecked={account.locked} />)}
        </Form.Item>

        {!isDebtor && (
          <Form.Item {...formItemLayout} label={t('Suma na investovanie')}>
            <span>{currencyFormatter(account.balance)}</span>
          </Form.Item>
        )}

        <Form.Item {...formItemLayout} label={t('Dátum vytvorenia')}>
          <span>{formatDateTime(account.createdAt)}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Dátum úpravy')}>
          <span>{formatDateTime(account.updatedAt)}</span>
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          {!isEditable && (
            <Button size="default" type="dashed" icon="edit" onClick={this.handleEdit}>
              {t('Upraviť údaje')}
            </Button>
          )}
          {isEditable && (
            <Button size="default" type="primary" icon="save" htmlType="submit">
              {t('Uložiť')}
            </Button>
          )}
          {isEditable && (
            <Button
              size="default"
              className="btn-inline"
              icon="close-circle-o"
              onClick={this.handleCancelEdit}
            >
              {t('Zrušiť úpravy')}
            </Button>
          )}
        </Form.Item>

        {!isEditable &&
          account.registrationStatus === accountRegistrationStatuses.DOCUMENTS_SUBMITTED && (
            <Form.Item {...tailFormItemLayout}>
              <AcceptDocumentsModal onSubmit={onAcceptDocuments}>
                <Button size="small" type="primary" icon="check">
                  {t('Schváliť OP')}
                </Button>
              </AcceptDocumentsModal>
              <RejectDocumentsModal onSubmit={this.handleRejectDocumentsSubmit}>
                <Button className="btn-inline" size="small" type="danger" icon="close-circle-o">
                  {t('Zamietnuť OP')}
                </Button>
              </RejectDocumentsModal>
            </Form.Item>
          )}
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/components/AccountForm.js